import { LOADING_STATUSES } from '@yandex-int/k-common/client/api/constants';
import { Notification, NotificationDataType } from '@yandex-int/k-common/typings/api/models';
import { createSelector } from 'reselect';

import { NotificationsStoreState, ReduxNotificationsStore } from './typings';

const notificationsSelector = (storeState: ReduxNotificationsStore): NotificationsStoreState =>
    storeState?.notifications;

export const getNotificationsList = createSelector(
    notificationsSelector,
    (storeState: NotificationsStoreState): Array<Notification<NotificationDataType>> => storeState.list
);

export const getFirstNotification = createSelector(
    getNotificationsList,
    (notifications): Notification<NotificationDataType> | null => (notifications.length > 0 ? notifications[0] : null)
);

export const getNotificationsLoadingStatus = createSelector(
    notificationsSelector,
    (storeState: NotificationsStoreState): LOADING_STATUSES => storeState.loadingStatus
);

export const getHeaderNotifications = createSelector(
    notificationsSelector,
    (storeState: NotificationsStoreState): Array<Notification<NotificationDataType>> => storeState.headerNotifications
);

export const getHeaderNotificationsLoadingStatus = createSelector(
    notificationsSelector,
    (storeState: NotificationsStoreState): LOADING_STATUSES => storeState.headerNotificationsLoadingStatus
);
